import { AlertTriangle, X } from 'lucide-react'

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'primary',
  isLoading = false
}) {
  if (!isOpen) return null

  const confirmButtonClasses = {
    primary: 'btn btn-primary',
    danger: 'btn btn-danger',
    warning: 'btn btn-warning',
    success: 'btn btn-success'
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                confirmVariant === 'danger' 
                  ? 'bg-red-100' 
                  : confirmVariant === 'warning'
                  ? 'bg-yellow-100'
                  : 'bg-blue-100'
              }`}>
                <AlertTriangle className={`w-5 h-5 ${
                  confirmVariant === 'danger' 
                    ? 'text-red-600' 
                    : confirmVariant === 'warning'
                    ? 'text-yellow-600'
                    : 'text-blue-600'
                }`} />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
            </div>
            <button
              onClick={onClose}
              disabled={isLoading}
              className="text-gray-400 hover:text-gray-600"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Message */}
          <div className="mb-6">
            <p className="text-gray-600">{message}</p>
          </div>

          {/* Actions */}
          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              disabled={isLoading}
              className="btn btn-secondary"
            >
              {cancelText}
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className={confirmButtonClasses[confirmVariant]}
            >
              {isLoading ? 'Processing...' : confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

// Simple confirmation hook
export function useConfirm() {
  const confirm = (options) => {
    return new Promise((resolve) => {
      const dialog = document.createElement('div')
      document.body.appendChild(dialog)
      
      // This would need to be implemented with a state management solution
      // For now, we'll use the component directly
      resolve(window.confirm(options.message || 'Are you sure?'))
    })
  }

  return confirm
}